<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="!$device.isMobile"
        v-on="on"
        :loading="processing"
        color="#606770"
        depressed
        text
        @click.once="remix()"
      >
        <v-icon class="mr-1" style="font-size: 21px;">
          $vuetify.icons.mdiCached
        </v-icon>
        <span class="hidden-xs-only">remix</span>
      </v-btn>
    </template>
    <span>Remix this story</span>
  </v-tooltip>
</template>
<script>
export default {
  props: {
    object: {
      type: [Object],
      required: true,
      default: function() {}
    }
  },
  data() {
    return {
      processing: false
    }
  },
  methods: {
    async remix() {
      if (!this.$auth.user) {
        return (this.$store.state.signupDialog = true)
      }

      let data = {
        slug: this.object.slug
      }
      if (
        this.$auth.user.is_student &&
        this.$store.state.studentSelectClass.slug
      ) {
        data.class_slug = this.$store.state.studentSelectClass.slug, 
        data.assignment_slug = this.$store.state.studentSelectClass.assignment.slug
      }

      try {
        this.processing = true
        const res = await this.$api.remixStory(data)
        this.$router.push(this.localePath(res.data.remix_url))
        // this.$store.state.draft_stories.results.splice(0, 0, res.data)
      } catch (e) {
        this.$toast.error(this.$i18n.t('toast.error'), {
          theme: 'bubble',
          duration: 5000
        })
      }
      this.processing = false
    }
  }
}
</script>
